(ns lupapalvelu.ui2.spinner
  (:require ["@carbon/icons-react/es/ProgressBarRound$default" :as ProgressBarRound]))

(defn spinner [{:keys [size]}]
  ;; FIXME: Carbon icon used as placeholder before a spinner
  ;; from the design system is ready?
  [:> ProgressBarRound
   {:size  (or size 128)
    :class "animate-spin"}])
